<template>
  <div>
    <sui-tree v-bind="fdpTreeData" mutiple class="tree-grid brdG01 pd20"/>
  </div>
</template>


<script>
export default {
  data() {return {
    fdpTreeData: {
      data: [
        {text: 'G-EHS', opened: true, children: [
          {text: 'Tree01 depth_1', opened: true, children: [
            {text: 'Tree01 depth_2', opened: true, children: [
              {text: 'Tree01 depth_30', opened: true, children: [
                {text: 'Tree01 depth_40'},
                {text: 'Tree01 depth_41'}
              ]}, 
              {text: 'Tree01 depth_31'},
              {text: 'Tree01 depth_32'},
              {text: 'Tree01 depth_33'},
              {text: 'Tree01 depth_34'}
            ]},
            {text: 'Tree01 depth_2'}
          ]},
          {text: 'Tree02 depth_1'},
          {text: 'Tree03 depth_1'},
          {text: 'Tree04 depth_1', opened: false, children: [
            {text: 'Tree04 depth_21'},
            {text: 'Tree04 depth_22'},
            {text: 'Tree04 depth_ long title 123456789_123456789_123456789_123456789_123456789.123456789_123456789_123456789_123456789_123456789.123456789_123456789_123456789_123456789_123456789.123456789_123456789_'}
          ]},
          {text: 'Tree05 depth_1'}
        ]
      }]
    },
  }}
}
</script>

<style scoped>
.tree-grid {height:250px; overflow-y:auto}
</style>